/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';

export const mainHeading = styled.div`
  font-size: 16px;
  font-weight: bold;
`;

export const Text = styled.div`
  font-size: 14px;
`;
export const paymentHeader = styled.div`
  font-size: 14px;
  text-align: left;
  font-weight: bold;
`;
export const paymentSubHeader = styled.div`
  font-size: 14px;
  text-align: left;
`;
export const heading = styled.h3`
  margin-top: 2%;
  font-size: 1.2rem;
`;
export const subheading = styled.h6`
  font-size: 14px;
`;
